import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { IframeContext } from '~/service/IframeConn'

type OpenClientProps = {
  client: {
    id: number
    externalId: string
  }
  children?: React.ReactNode
}

export const OpenClient: React.FC<OpenClientProps> = ({ client, children }) => {
  const iframeContext = useContext(IframeContext)

  const onClick =
    (aux: boolean) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (window.isIframe) {
        e.preventDefault()

        iframeContext.parentRef.current?.goToClient(
          client.id,
          client.externalId,
          aux
        )
      }
    }

  return (
    <div className="openInAgent">
      <a
        href={'https://' + process.env.AGENT_DOMAIN + '/client/' + client.id}
        target="_blank"
        onClick={onClick(false)}
        onAuxClick={onClick(true)}
      >
        {children ? (
          children
        ) : (
          <>
            <FormattedMessage id="client / open in agent console" />
            <span className="far fa-external-link" />
          </>
        )}
      </a>
    </div>
  )
}
